import React from 'react';
export function PremiumModules() {
  const modules = [{
    emoji: '📋',
    title: 'Informes Clínicos Listos'
  }, {
    emoji: '🤝',
    title: 'Reuniones Efectivas'
  }, {
    emoji: '💬',
    title: 'Comunicación Profesional'
  }, {
    emoji: '📑',
    title: 'Protocolos Listos'
  }, {
    emoji: '🏛️',
    title: 'Sistema Institucional Completo'
  }];
  return <section className="w-full bg-transparent py-16" data-id="element-198">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-199">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 text-center" data-id="element-200">
          <span className="tracking-wide font-[700] font-['Open_Sans',_sans-serif] text-[#CAB072]" data-id="element-201">
            Kit Profesional Completo™
          </span>{' '}
          incluye:
        </h2>
        <p className="text-center text-gray-400 mb-12" data-id="element-202">
          5 módulos profesionales listos para usar desde el primer día
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-203">
          {modules.map((mod, index) => <div key={index} className="flex items-center gap-4 bg-[#1A1A1A] border border-[#2A2A2A] p-5 rounded-lg hover:border-[#D4A843]/40 transition-colors duration-200" data-id="element-204">
              <span className="text-3xl flex-shrink-0" data-id="element-205">{mod.emoji}</span>
              <div data-id="element-206">
                <span className="text-xs text-[#D4A843] font-semibold tracking-wider uppercase" data-id="element-207">
                  Módulo {index + 1}
                </span>
                <p className="text-white font-bold text-lg leading-tight mt-0.5" data-id="element-208">
                  {mod.title}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}